// https://developers.facebook.com/ads/blog/post/2017/11/28/event-tracking-with-multiple-pixels-tracksingle/

const InvestmentAtPersonalInfoStepEvent  = "Investment-Step1-PersonalInfo";
const InvestmentAtQuestionnaireStepEvent = "Investment-Step2-Questionnaire";
const InvestmentAtPaymentMethodStepEvent = "Investment-Step3-PaymentMethod";
const InvestmentAtConfirmationStepEvent  = "Investment-Step4-Confirmation";
const InvestmentSuccessfullyCreatedEvent = "Investment-Step5-Created";

export const investmentAtPersonalInfoStep = (investment) => {
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: InvestmentAtPersonalInfoStepEvent
  })
}

export const investmentAtQuestionnaireStep = (investment) => {
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: InvestmentAtQuestionnaireStepEvent
  })
}

export const investmentAtPaymentMethodStep = (investment) => {
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: InvestmentAtPaymentMethodStepEvent
  })
}

export const investmentAtConfirmationStep = (investment) => {
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: InvestmentAtConfirmationStepEvent
  })
}

export const investmentSuccessfullyCreated = (investment) => {
  if (typeof gtag === 'undefined') return
  // Event snippet for Investment abgeschlossen conversion page
  gtag('event', 'conversion', {
    'send_to': 'AW-432749837/tyLiCL_z5fkBEI36rM4B',
    'transaction_id': '',
    event: InvestmentSuccessfullyCreatedEvent
  })
  if (typeof dataLayer === 'undefined') return
  dataLayer.push({
    event: InvestmentSuccessfullyCreatedEvent
  })
}
